var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',{attrs:{"title":"材料处理完成","pic":_vm.IMAGE_MAP.UPLOADED_PAGE_ICON}})}
var staticRenderFns = []

export { render, staticRenderFns }